import { useMutation } from "react-query";
import { updateSecurity } from "../../../../actions/CarrierAgreementMgmt/Security";

const useEditSecurity = () => {
  return useMutation(updateSecurity);
};
export default useEditSecurity;
